import capitalize from "lodash/capitalize";

function defaultParams({ snapshotState = false } = {}) {
  return {
    config: {
      snapshotState
    },
    params: [
      {
        label: "Search...",
        name: "keyword",
        value: ""
      },
      {
        label: "Tag",
        name: "tag",
        options: []
      },
      {
        label: "Kind",
        name: "kind",
        options: []
      },
      {
        hidden: true,
        label: "Resource Collection",
        name: "resourceCollection",
        value: ""
      },
      {
        label: "Order",
        name: "order",
        value: "",
        options: [
          { label: "In default order", value: "" },
          { label: "Alphabetical by title", value: "sort_title ASC" },
          { label: "Newest resources first", value: "created_at DESC" }
        ]
      }
    ]
  };
}

function dynamicParams(searchProps, project) {
  if (!project) return searchProps;

  const tagFilterOptions = () => {
    const tags = project.attributes.resourceTags || [];
    const options = tags.map(t => ({ label: t, value: t }));
    options.unshift({ label: "All", value: "" });
    return options;
  };

  const kindFilterOptions = () => {
    const tags = project.attributes.resourceKinds || [];
    const options = tags.map(k => ({ label: capitalize(k), value: k }));
    options.unshift({ label: "All", value: "" });
    return options;
  };

  const searchParams = () => {
    const { params } = searchProps;
    const tag = params.find(p => p.name === "tag");
    tag.options = tagFilterOptions();
    const kind = params.find(p => p.name === "kind");
    kind.options = kindFilterOptions();
    return params;
  };

  return { ...searchProps, params: searchParams() };
}

export default {
  defaultParams,
  dynamicParams
};
